import React, { useMemo, useContext } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { CloudDownloadRounded, VisibilityRounded, DeleteForeverRounded } from "@material-ui/icons/";
import { MDropzoneContext } from "components/Shared/MDropzone/contexts";
import { Button } from "components/Shared";
import { buildURI, canPreviewExtension } from "components/Shared/Formatters";
import { CASE_FILE_DOWNLOAD, CASE_FILE_DELETE } from "typeConstants/rights";

const FileActions = ({ file, rights, token, rightOverrides }) => {
  const { onPreview, removeFile } = useContext(MDropzoneContext);
  const downloadEnabled = rightOverrides?.download ?? useMemo(() => rights && rights.includes(CASE_FILE_DOWNLOAD), [rights]);
  const deleteEnabled = rightOverrides?.delete ?? useMemo(() => rights && rights.includes(CASE_FILE_DELETE), [rights]);
  const canPreview = rightOverrides?.preview ?? canPreviewExtension(file.name);

  return (
    <div className={"FileActions-Root"}>
      <Button
        className={downloadEnabled ? "FileDownload-Root-Enabled" : ""}
        {...downloadEnabled && { href: buildURI(file.downloadUrl, token) }}
        {...canPreview && { target: "_blank", rel: "noopener noreferrer" }}
        disabled={!downloadEnabled}
        icon={<CloudDownloadRounded />}
        title={downloadEnabled ? "Download File" : "Insufficient Permissions"}
      />
      <Button
        disabled={!canPreview}
        onClick={() => onPreview(file, buildURI(file.viewUrl, token))}
        icon={<VisibilityRounded />}
        title={canPreview ? "Preview File" : "File Type Not Supported For Preview"}
      />
      <Button
        disabled={!deleteEnabled}
        onClick={e => {
          if (e) e.stopPropagation();
          removeFile(file);
        }}
        icon={<DeleteForeverRounded />}
        title={deleteEnabled ? "Delete File" : "Insufficient Permissions"}
        dialogProps={{
          title: "Delete Confirmation",
          children: `Are You Sure You Want To Delete "${file.name}"? This Operation Cannot Be Undone.`
        }}
      />
    </div>);
};

FileActions.propTypes = {
  file: PropTypes.object.isRequired,
  rights: PropTypes.array,
  token: PropTypes.string,
  rightOverrides: PropTypes.bool,
};

export default connect(
  state => ({
    rights: state.user.profile.rights,
    token: state.user.profile.token,
  })
)(FileActions);